module.exports = __webpack_public_path__ + "img/csr_110923_C.e590e9a5.jpg";